import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Ghost } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1B1B1F] text-white" dir="rtl">
      <div className="container mx-auto px-4 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-right">

          {/* Company Info */}
          <div>
            <h3
              className="text-xl font-extrabold mb-4"
              style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
            >
              MEME STORE
            </h3>

            <p className="text-gray-400 text-sm mb-4 leading-7">
              تسوق أونلاين من أفضل المنتجات والعلامات التجارية بأسعار مميزة وتجربة تسوق سهلة وآمنة.
            </p>

            {/* Social Media */}
            <div className="flex gap-4 mt-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="text-gray-400 hover:text-[#F2B705] transition-colors"
              >
                <Facebook size={22} />
              </a>

              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
                className="text-gray-400 hover:text-[#F2B705] transition-colors"
              >
                <Twitter size={22} />
              </a>

              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-gray-400 hover:text-[#F2B705] transition-colors"
              >
                <Instagram size={22} />
              </a>

              <a
                href="https://snapchat.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Snapchat"
                className="text-gray-400 hover:text-[#F2B705] transition-colors"
              >
                <Ghost size={22} />
              </a>
            </div>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="font-bold mb-4">خدمة العملاء</h4>

            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/help-center" className="hover:text-[#F2B705] transition-colors">
                  مركز المساعدة
                </Link>
              </li>

              <li>
                <Link to="/contact-us" className="hover:text-[#F2B705] transition-colors">
                  اتصل بنا
                </Link>
              </li>

              <li>
                <Link to="/return-policy" className="hover:text-[#F2B705] transition-colors">
                  سياسة الإرجاع
                </Link>
              </li>

              <li>
                <Link to="/shipping-policy" className="hover:text-[#F2B705] transition-colors">
                  الشحن والتوصيل
                </Link>
              </li>
            </ul>
          </div>

          {/* About MEME */}
          <div>
            <h4 className="font-bold mb-4">الروابط المفيدة</h4>

            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/about-us" className="hover:text-[#F2B705] transition-colors">
                  من نحن
                </Link>
              </li>

              <li>
                <Link to="/careers" className="hover:text-[#F2B705] transition-colors">
                  الوظائف
                </Link>
              </li>

              <li>
                <Link to="/news" className="hover:text-[#F2B705] transition-colors">
                  الأخبار
                </Link>
              </li>

              <li>
                <Link to="/investors" className="hover:text-[#F2B705] transition-colors">
                  المستثمرون
                </Link>
              </li>
            </ul>
          </div>

          {/* Popular Categories */}
          <div>
            <h4 className="font-bold mb-4">الفئات الشائعة</h4>

            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/category/toys" className="hover:text-[#F2B705] transition-colors">
                  الألعاب
                </Link>
              </li>

              <li>
                <Link to="/category/books" className="hover:text-[#F2B705] transition-colors">
                  الكتب
                </Link>
              </li>

              <li>
                <Link to="/category/mens-fashion" className="hover:text-[#F2B705] transition-colors">
                  الأزياء
                </Link>
              </li>

              <li>
                <Link to="/category/beauty-perfumes" className="hover:text-[#F2B705] transition-colors">
                  الجمال والعطور
                </Link>
              </li>

              <li>
                <Link to="/category/electronics" className="hover:text-[#F2B705] transition-colors">
                  الإلكترونيات
                </Link>
              </li>

              <li>
                <Link to="/category/home-furniture" className="hover:text-[#F2B705] transition-colors">
                  المنزل والأثاث
                </Link>
              </li>

              <li>
                <Link to="/category/grocery" className="hover:text-[#F2B705] transition-colors">
                  البقالة
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-white/10 mt-8 pt-8">
          <div className="flex flex-col md:flex-row md:flex-row-reverse justify-between items-center">
            <div className="text-sm text-gray-500 mb-4 md:mb-0">
              © 2025 جميع الحقوق محفوظة MEME STORE
            </div>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500">
              <Link to="/terms" className="hover:text-[#F2B705] transition-colors">
                الشروط والأحكام
              </Link>

              <Link to="/privacy-policy" className="hover:text-[#F2B705] transition-colors">
                سياسة الخصوصية
              </Link>

              <Link to="/cookies-policy" className="hover:text-[#F2B705] transition-colors">
                ملفات تعريف الارتباط
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
